import {Typography} from '@material-ui/core';
import React from 'react';

const P = ({children, ...rest}) => {
    // paragraph format => will have an extra space after
    return (
        <Typography paragraph variant='body1' {...rest}>
            {children}
        </Typography>
    );
};

const PSingleLine = ({children, ...rest}) => {
    // paragraph format => will have an extra space after
    return (
        <Typography variant='body1' {...rest}>
            {children}
        </Typography>
    );
};

const PBold = ({children, ...rest}) => {
    return (
        <Typography
            style={{fontWeight: 'bold', ...rest.style}}
            variant='body1'
            {...rest}
        >
            {children}
        </Typography>
    );
};

const BoldSpan = ({children, ...rest}) => {
    return (
        <span style={{fontWeight: 'bold', ...rest.style}} {...rest}>
            {children}
        </span>
    );
};

const PList = ({children, ...rest}) => {
    // no gutter/ extra spacing on the botton
    return (
        <Typography variant='body2' {...rest}>
            {children}
        </Typography>
    );
};

const Subtitle = ({children, ...rest}) => {
    return (
        <Typography variant='subtitle1' {...rest}>
            {children}
        </Typography>
    );
};

const H6 = ({children, ...rest}) => {
    return (
        <Typography variant='h6' component='h6' {...rest}>
            {children}
        </Typography>
    );
};

const H5 = ({children, ...rest}) => {
    return (
        <Typography variant='h5' component='h5' gutterBottom {...rest}>
            {children}
        </Typography>
    );
};
const H4 = ({children, ...rest}) => {
    return (
        <Typography variant='h4' component='h4' gutterBottom {...rest}>
            {children}
        </Typography>
    );
};

const H3 = ({children, ...rest}) => {
    return (
        <Typography variant='h3' component='h3' gutterBottom {...rest}>
            {children}
        </Typography>
    );
};

const H2 = ({children, ...rest}) => {
    return (
        <Typography variant='h2' component='h2' {...rest}>
            {children}
        </Typography>
    );
};

export {P, PList, PBold, BoldSpan, Subtitle, H6, H5, H4, H3, H2, PSingleLine};
